import { getAuthorizationHeader } from './auth';
import axios from 'axios';

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_SERVER_HOST,
});

axiosInstance.interceptors.request.use(
  config => {
    config.headers.authorization = getAuthorizationHeader();
    return config;
  },
  error => Promise.reject(error)
);

const get_file_name = headers => {
  return headers['content-disposition'].split('filename=')[1].replace(/^"(.*)"$/, '$1');
};

export { axiosInstance, get_file_name };